var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-checkbox',{staticClass:"m-0",on:{"change":_vm.input},model:{value:(_vm.isSelected),callback:function ($$v) {_vm.isSelected=$$v},expression:"isSelected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }